import { render } from "./GetSumUIDialog.vue?vue&type=template&id=3a850979"
import script from "./GetSumUIDialog.vue?vue&type=script&lang=js"
export * from "./GetSumUIDialog.vue?vue&type=script&lang=js"

import "./GetSumUIDialog.vue?vue&type=style&index=0&id=3a850979&lang=sass"
import "./GetSumUIDialog.vue?vue&type=style&index=1&id=3a850979&lang=scss"
script.render = render

export default script